import { useTranslation } from 'react-i18next';

const STEP_COUNT = 2;
const stepIndices = Array.from({ length: STEP_COUNT }, (_, i) => i);

export default function LearningProgression() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('coursesEssential.progression.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesEssential.progression.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {String(t('coursesEssential.progression.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed">{__s}</p>))}
        </div>

        <div className="space-y-6">
          {stepIndices.map((index) => (
            <div
              key={index}
              className="flex gap-5 md:gap-6 items-start bg-background-50 border border-background-200/60 p-6 md:p-7"
            >
              <span className="flex-shrink-0 w-10 h-10 rounded-full bg-accent-500/10 border border-accent-500/30 flex items-center justify-center font-heading text-accent-600 text-[15px]">
                {index + 1}
              </span>
              <div>
                <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2">
                  {t(`coursesEssential.progression.${index}.title`)}
                </h3>
                <p className="text-[15px] text-foreground-700 leading-relaxed tracking-[0.03em]">
                  {t(`coursesEssential.progression.${index}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {String(t('coursesEssential.progression.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mt-6 text-center">{__s}</p>))}
      </div>
    </section>
  );
}
